import { render, staticRenderFns } from "./SubPageNavigation.vue?vue&type=template&id=6ac31b3a&scoped=true&"
import script from "./SubPageNavigation.vue?vue&type=script&lang=js&"
export * from "./SubPageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SubPageNavigation.vue?vue&type=style&index=0&id=6ac31b3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac31b3a",
  null
  
)

export default component.exports